

// export const schedulerTrackServiceBaseUrl = 'https://ziyobrpjcf.execute-api.us-west-2.amazonaws.com/Dev'; 
// export const schedulerSharedServiceBaseUrl = ''; 
// export const OKTA_CLIENT_ID = "0oa11fqd7tahbgmUU0h8";
// export const OKTA_ISSUER_URL = "https://twdev.oktapreview.com/oauth2/default";
// export const OKTA_REDIRECT_URL = window.location.origin + '/callback';
// export const OKTA_URL = "https://twdev.oktapreview.com";
// export const IDLE_TIMEOUT = "60";
// export const IDLE_WARN_TIMEOUT = "30";



export const SchedulerServiceBaseUrl = 'https://api.qa.scheduler.warnerbros.com';  
// export const SchedulerServiceBaseUrl = 'https://ziyobrpjcf.execute-api.us-west-2.amazonaws.com/Dev'; 
export const schedulerSharedServiceBaseUrl = ''; 
export const OKTA_CLIENT_ID = "0oa1cfl0zv2BKY67C0h8";
export const OKTA_ISSUER_URL = "https://ssoqa.wbd.com/oauth2/default";
export const OKTA_REDIRECT_URL = window.location.origin + '/callback';
export const OKTA_URL = "https://sso.wbd.com";
export const IDLE_TIMEOUT = "60";
export const IDLE_WARN_TIMEOUT = "30";
export const FULL_CALENDAR_KEY="0273663870-fcs-1663942375"

